module.exports = __webpack_public_path__ + "img/home_light.9b71f10c.png";